import { CompanyStatus, companyStatusLabel, type Country } from "@pentacode/core";
import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { config, shared } from "../../styles";
import { base } from "../../styles/base";
import { Popover } from "../popover";
import type { CompanyFilter } from "./company-filter.util";

export type CompanyFilterPopoverChangeEvent = CustomEvent<CompanyFilter>;

@customElement("ptc-company-filter-popover")
export class CompanyFilterPopover extends Popover {
    @query("#company-filter-form")
    private _form: HTMLFormElement;

    private _getFilter(): CompanyFilter {
        const formData = new FormData(this._form);
        const status = formData.get("status") as CompanyStatus | "";
        const country = formData.get("country") as Country | "";

        return {
            status: status ? status : undefined,
            country: country ? country : undefined,
        };
    }

    private _fireChangeEvent(filter: CompanyFilter = {}) {
        this.dispatchEvent(new CustomEvent<CompanyFilter>("change", { detail: filter }));
    }

    static styles = [config, base, shared, ...Popover.styles];

    renderContent() {
        return html`<div>
            <form
                id="company-filter-form"
                class="padded layout vertical wrapping spacing"
                @change=${() => this._fireChangeEvent(this._getFilter())}
                @reset=${() => {
                    this._fireChangeEvent();
                }}
            >
                <select class="skinny" name="status">
                    <option .value=${""}>Alle Stati</option>
                    <option .value=${CompanyStatus.TrialWithoutContract}>
                        ${companyStatusLabel(CompanyStatus.TrialWithoutContract)}
                    </option>
                    <option .value=${CompanyStatus.Trialing}>${companyStatusLabel(CompanyStatus.Trialing)}</option>
                    <option .value=${CompanyStatus.Probation}>${companyStatusLabel(CompanyStatus.Probation)}</option>
                    <option .value=${CompanyStatus.Active}>${companyStatusLabel(CompanyStatus.Active)}</option>
                    <option .value=${CompanyStatus.Paused}>${companyStatusLabel(CompanyStatus.Paused)}</option>
                    <option .value=${CompanyStatus.Canceled}>${companyStatusLabel(CompanyStatus.Canceled)}</option>
                    <option .value=${CompanyStatus.PaymentOverdue}>
                        ${companyStatusLabel(CompanyStatus.PaymentOverdue)}
                    </option>
                </select>
                <select class="skinny" name="country">
                    <option .value=${""}>Alle Länder</option>
                    <option .value=${"DE"}>Deutschland</option>
                    <option .value=${"AT"}>Österreich</option>
                </select>
                <input type="reset" value="Reset" />
            </form>
        </div>`;
    }
}
